import {
  IFetchItemCommercialTranslationActionPayload,
  IItemCommercialTranslationActions,
  ItemCommercialTranslationContext
} from './actions.types';
import { IItemCommercialTranslationData } from '@/models';
import { IItemCommercialTranslationPaginatedListData } from '@/services/itemcommercialtranslation';

export const actions: IItemCommercialTranslationActions = {
  fetchItemCommercialTranslations(
    context: ItemCommercialTranslationContext,
    payload: IFetchItemCommercialTranslationActionPayload
  ): Promise<void> {
    return this.$services.itemCommercialTranslation
      .fetchItemCommercialTranslations(payload.page, payload.search)
      .then((paginatedData: IItemCommercialTranslationPaginatedListData) => {
        context.commit(
          'SET_ITEM_COMMERCIAL_TRANSLATIONS',
          paginatedData.results
        );
        context.commit('SET_COUNT', paginatedData.count);
      });
  },

  fetchItemCommercialTranslation(
    context: ItemCommercialTranslationContext,
    payload: number
  ): Promise<void> {
    return this.$services.itemCommercialTranslation
      .fetchItemCommercialTranslation(payload)
      .then((itemCommercialTranslation: IItemCommercialTranslationData) => {
        const index = context.state.itemCommercialTranslations.findIndex(
          (v: IItemCommercialTranslationData) =>
            v.id === itemCommercialTranslation.id
        );
        if (index === -1) {
          context.commit(
            'ADD_ITEM_COMMERCIAL_TRANSLATION',
            itemCommercialTranslation
          );
          context.commit('INCREMENT_COUNT');
        } else {
          context.commit(
            'UPDATE_ITEM_COMMERCIAL_TRANSLATION',
            itemCommercialTranslation
          );
        }
      });
  },

  createItemCommercialTranslation(
    context: ItemCommercialTranslationContext,
    payload: IItemCommercialTranslationData
  ): Promise<void> {
    return this.$services.itemCommercialTranslation
      .createItemCommercialTranslation(payload)
      .then((itemCommercialTranslation: IItemCommercialTranslationData) => {
        context.commit(
          'ADD_ITEM_COMMERCIAL_TRANSLATION',
          itemCommercialTranslation
        );
        context.commit('INCREMENT_COUNT');
      });
  },

  updateItemCommercialTranslation(
    context: ItemCommercialTranslationContext,
    payload: IItemCommercialTranslationData
  ): Promise<void> {
    return this.$services.itemCommercialTranslation
      .updateItemCommercialTranslation(payload)
      .then((itemCommercialTranslation: IItemCommercialTranslationData) => {
        const index = context.state.itemCommercialTranslations.findIndex(
          (v: IItemCommercialTranslationData) =>
            v.id === itemCommercialTranslation.id
        );
        if (index === -1) {
          context.commit(
            'ADD_ITEM_COMMERCIAL_TRANSLATION',
            itemCommercialTranslation
          );
          context.commit('INCREMENT_COUNT');
        } else {
          context.commit(
            'UPDATE_ITEM_COMMERCIAL_TRANSLATION',
            itemCommercialTranslation
          );
        }
      });
  },

  deleteItemCommercialTranslation(
    context: ItemCommercialTranslationContext,
    payload: number
  ): Promise<void> {
    return this.$services.itemCommercialTranslation
      .deleteItemCommercialTranslation(payload)
      .then(() => {
        context.commit('REMOVE_ITEM_COMMERCIAL_TRANSLATION', payload);
        context.commit('DECREMENT_COUNT');
      });
  },

  uploadItemCommercialTranslationFile(
    _: ItemCommercialTranslationContext,
    payload: File
  ): Promise<void> {
    return this.$services.itemCommercialTranslation
      .uploadItemCommercialTranslationFile(payload)
      .then(() => {
        return;
      });
  },

  exportItemCommercialTranslations(
    _: ItemCommercialTranslationContext
  ): Promise<Blob> {
    return this.$services.itemCommercialTranslation.exportItemCommercialTranslations();
  }
};
